const localUserDateFieldsByEntity = {
  activitypointer: new Set(["createdon", "modifiedon"]),
  g4c_communicationactivity: new Set([
    "createdon",
    "modifiedon",
    "scheduledstart",
  ]),
  g4c_communication: new Set(["g4c_startdate", "g4c_enddate"]),
  g4c_communicationaudit: new Set([
    "createdon",
    "modifiedon",
    "g4c_auditdate",
  ]),
  g4c_abtest: new Set([
    "g4c_startdate",
    "g4c_enddate",
    "g4c_testperiodenddate",
  ]),
  g4gdpr_contactaudit: new Set([
    "createdon",
    "modifiedon",
    "g4gdpr_modifiedon",
  ]),
  list: new Set(["createdon", "modifiedon"]),
};

const maintainEnteredDateTimeFieldsByEntity = {};

const hasDateFieldRule = (
  entityFieldMap,
  entityName,
  fieldName
) => {
  if (!entityName || !fieldName) {
    return false;
  }

  return entityFieldMap[entityName]?.has(fieldName) ?? false;
};

const isLocalUserDateField = (entityName, fieldName) =>
  hasDateFieldRule(
    localUserDateFieldsByEntity,
    entityName,
    fieldName
  );

const shouldConvertUtcToLocalForEditForm = (
  entityName,
  fieldName
) => isLocalUserDateField(entityName, fieldName);

const shouldMaintainEnteredDateTime = (entityName, fieldName) =>
  hasDateFieldRule(
    maintainEnteredDateTimeFieldsByEntity,
    entityName,
    fieldName
  );

export {
  isLocalUserDateField,
  localUserDateFieldsByEntity,
  maintainEnteredDateTimeFieldsByEntity,
  shouldConvertUtcToLocalForEditForm,
  shouldMaintainEnteredDateTime,
};

export default localUserDateFieldsByEntity;
